<!--公司介绍-->
<template>
  <div class="solution2">
    <!--顶部介绍-->
    <div class="x-top">
      <guide :guide="guide"></guide>
      <div class="x-top-container">
      </div>
    </div>
    <!--主体内容-->
    <div class="x-container">
      <!--背景介绍-->
      <section class="x-section">
        <p class="x-title">热招岗位</p>
      </section>
      <section>
        <!--轮播图-->
        <!--<div class="carousel">-->
        <!--&lt;!&ndash;中间图片&ndash;&gt;-->
        <!--<div ref="swiper-container" class="swiper-container swiper-container2">-->
        <!--<div ref="swiper-wrapper" class="swiper-wrapper">-->
        <!--<div class="swiper-slide" v-for="(item,index) in carousels" :key="'carousel'+index">-->
        <!--<picture>-->
        <!--<source media="(min-width: 768px)" :srcset="item.imgSrc">-->
        <!--<source media="(min-width: 320px)" :srcset="item.imgSrcMobile">-->
        <!--<img :src="item.imgSrc">-->
        <!--</picture>-->
        <!--</div>-->
        <!--</div>-->
        <!--<div class="swiper-pagination"></div>-->
        <!--</div>-->
        <!--</div>-->
        <div class="job-container">
          <div class="job" v-for="(item,index) in jobs" :key="'job'+index">
            <p class="title">{{item.label}}</p>
            <div class="job-des">
              <p class="second-title">岗位职责</p>
              <ul>
                <li v-for="(jtem,index) in item.content" :key="'content'+index">
                  {{index+1+'、'+jtem.label}}
                </li>
              </ul>
            </div>
            <div class="job-des" style="margin-top: 1rem">
              <p class="second-title">任职要求</p>
              <ul>
                <li v-for="(jtem,index) in item.content2" :key="'content2'+index">
                  {{index+1+'、'+jtem.label}}
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
  import guide from '@/components/guide'

  export default {
    name: "solution1",
    components: {
      guide,
    },
    data() {
      return {
        guide: [
          // {label: '格力智能楼宇'},
          {label: '关于我们'},
          {label: '诚聘英才'},
        ],
        jobs: [
          {
            label: 'Java高级工程师',
            content: [
              {label:'负责公司开发平台服务端架构设计及软件研发工作;'},
              {label:'负责与研发团队协作，支撑研发团队高效、高质量完成产品研发;'},
              {label:'负责平台大数据开发，包括数据的采集、处理、存储等。'},
            ],
            content2:[
              {label:'本科3年及以上相关工作经验，硕士1年以上相关工作经验;'},
              {label:'熟悉分库分表技术、消息中间件、分布式框架及各种主流技术架构，熟悉Docker技术、kubernetes等技术者优先;'},
              {label:'熟悉Redis、MQ、Kafka、ELK、Zookeeper、Nginx、Kong等中间件/技术的原理并有丰富的使用经验;'},
              {label:'能够独立胜任产品架构设计，熟悉大型央企软件项目安全设计要求，能研究和解决项目中技术难题以及性能调优。'},
            ]
          },
          {
            label: '前端中级工程师',
            content: [
              {label:'前后端数据交互以及页面交互等模块的开发，通用类库、框架编写和维护;'},
              {label:'保持高效的前端性能，维护前端代码，保证良好的浏览器兼容性;'},
              {label:'负责前端开发规范的制定，开发任务的协调。'},
            ],
            content2:[
              {label:'本科3年及以上相关工作经验，硕士1年以上相关工作经验;'},
              {label:'精通CSS3, HTML5, 熟悉W3C标准和网络分层协议，熟悉微信公众号开发优先;'},
              {label:'精通或熟悉下列的一种或多种框架: Vue、React、AngularJS;'},
              {label:'熟悉团队开发流程，熟练使用git工具进行代码管理;'},
              {label:'热情，酷爱技术，良好的团队合作精神。'},
            ]
          },
          {
            label: '硬件工程师',
            content: [
              {label:'负责产品硬件电路设计，电路器件选型，原理图设计和PCB设计;'},
              {label:'负责硬件电路测试，调试，配合其他工程师进行联调;'},
              {label:'负责产品生命周期的稳定性和品质保障。'},
            ],
            content2:[
              {label:'3年及以上相关经验，本科及以上学历，电子、电气、自动化等相关专业;'},
              {label:'硬件基础扎实，熟悉模拟电路、数字电路及电源电路设计;'},
              {label:'熟悉电磁兼容设计，ESD防护设计;'},
              {label:'熟悉使用基本的测试仪器和焊接设备，如示波器、信号发生器等;'},
              {label:'熟练使用PADS等电路设计软件。'},
            ]
          },
          {
            label: '产品设计工程师',
            content: [
              {label:'负责产品方案设计，包含需求分析、功能策划、交互设计;'},
              {label:'负责智慧建筑行业解决方案开发;'},
              {label:'负责产品相关推广材料编写。'},
            ],
            content2:[
              {label:'本科及以上学历;'},
              {label:'具有一定的软件开发经验或者软件开发基础;'},
              {label:'具备产品需求分析、交互设计工作经验者优先;'},
              {label:'熟悉office办公软件、Xmind等办公软件的使用;'},
              {label:'具备较好的沟通协调能力。'},
            ]
          },
        ],
        // 轮播图
        mySwiper: null,
        carousels: [
          {
            imgSrc: require("@/assets/img/pc/about/about1/pic1.png"),
            imgSrcMobile: require("@/assets/img/mobile/about/about1/pic1.png"),
          },
          {
            imgSrc: require("@/assets/img/pc/about/about1/pic2.png"),
            imgSrcMobile: require("@/assets/img/mobile/about/about1/pic2.png"),
          },
        ]
      }
    },
    methods: {
      // 初始化工程案例轮播图
      initSwiperProjects() {
        this.mySwiper = new Swiper('.swiper-container2', {
          // autoplay: true,
          autoplay: {
            disableOnInteraction: false,
          },
          pagination: {
            el: '.swiper-pagination'
          },
          spaceBetween: 6,
          delay: 1000,
          loop: true,
          slidesPerView: 1,
          slidesPerGroup: 1,
          speed: 1000,
          grabCursor: true,
          breakpoints: {
            320: {
              // autoplay: true,
              // loop: true,
              slidesPerView: 1,
              slidesPerGroup: 1,
            }
          }
        })
      },
    },
    mounted() {
      this.initSwiperProjects();
    }
  }
</script>

<style scoped lang="less">
  .x-top {
    min-height: 23rem;
    .x-top-img {
      text-align: right;
      img {
        width: 20rem;
      }
    }
  }

  .job-container {
    .job {
      width: 80%;
      margin: auto;
      margin-bottom: 3rem;
      padding: 1rem;
      min-height: 30rem;
      background: #fff;
      box-shadow: 0 0 5px rgba(0, 0, 0, 0.3);
      border-radius: 15px;
      .title {
        font-size: 1.1rem;
        padding: 1rem;
        color: @deepblue;
      }
      .job-des {
        width: 80%;
        margin: auto;
        .second-title {
          text-align: left;
          margin-bottom: 1rem;
        }
        ul{
          li{
            font-size: 0.8rem;
            text-align: left;
            margin-bottom: 0.5rem;
            line-height: 1.5rem;
          }
        }
      }
    }
  }

  /*轮播图*/
  .carousel {
    .swiper-container {
      padding-bottom: 2rem;
    }
  }
</style>
<style lang="less" scoped>
  @media only screen and (min-width: 320px) {
    .x-top {
      background: url("../../../assets/img/mobile/about/about1/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }
  }

  @media only screen and (min-width: 768px) {
    .x-top {
      background: url("../../../assets/img/pc/about/about1/background.png") !important;
      background-repeat: no-repeat !important;
      background-size: cover !important;
      background-position: center center !important;
      box-sizing: border-box !important;
    }
  }
</style>
